module.exports = __webpack_public_path__ + "static/Vector 6-b9b1755b4d9dd340fbe724577ebbfa67.png";